import { createContext, useContext } from 'react';
import { BlockType, ElementType } from '../../../types/api/ElementType';

type WidgetFrameContextProps = {
  titleOverwrittenBy?: string;
  widgetElementType: ElementType | BlockType;
  widgetUuid: string;
  widgetId: string;
  header: boolean;
};

export const WidgetFrameContext = createContext<WidgetFrameContextProps | undefined>(undefined);

export const useWidgetContext = () => {
  const value = useContext(WidgetFrameContext);
  if (value === undefined) throw Error('WidgetFrameContext is used without Provider');
  return value;
};

export default WidgetFrameContext;
